import { useNavigate } from "react-router-dom";

export const useNavigateHelper = () => {
    const navigate = useNavigate();
    return navigate;
};